import { ApiService } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.caseWithWorkCaseDocument>[0];
export const getCaseForDocument = createAsyncSaga(
  LIS.DOCUMENT.GET_CASE.REQUEST,
  LIS.DOCUMENT.GET_CASE.SUCCESS,
  LIS.DOCUMENT.GET_CASE.ERROR,
  (args: GetArgs) => `document/${args.id}/case`,
  (args: GetArgs) => ApiService.caseWithWorkCaseDocument(args)
) as AsyncSagaAction<GetArgs>;

type StationDocumentArgs = Parameters<
  typeof ApiService.retrieveAdminCaseDocument
>[0];
export const loadStationDocument = createAsyncSaga(
  LIS.DOCUMENT.STATION_DOCUMENT.REQUEST,
  LIS.DOCUMENT.STATION_DOCUMENT.SUCCESS,
  LIS.DOCUMENT.STATION_DOCUMENT.ERROR,
  (args: StationDocumentArgs) => `document/station/${args.id}`,
  (args: StationDocumentArgs) => ApiService.retrieveAdminCaseDocument(args),
  {
    skipDuplicates: false,
  }
) as AsyncSagaAction<StationDocumentArgs>;
